<template>
  <section id="usps" aria-labelledby="usps-heading" class="usps-section">
    <div class="max-w-screen-xl mx-auto px-4">

      <!-- Header -->
      <div class="usps-header">
        <span class="eyebrow">Waarom Plug2Charge</span>
        <h2 id="usps-heading" class="usps-title">Duurzaam beginnen was<br>nog nooit zo makkelijk</h2>
      </div>

      <!-- 4 kaarten in één rij -->
      <ul class="usps-grid" role="list">
        <li v-for="(usp, i) in usps" :key="usp.title" class="usp-card">
          <div class="usp-top">
            <span class="usp-num">{{ String(i + 1).padStart(2, '0') }}</span>
            <div class="usp-icon" aria-hidden="true">
              <i :class="`bi ${usp.icon}`"></i>
            </div>
          </div>
          <h3 class="usp-title">{{ usp.title }}</h3>
          <p class="usp-body">{{ usp.body }}</p>
        </li>
      </ul>

      <!-- Footer link -->
      <div class="usps-footer">
        <router-link to="/hoe-het-werkt" class="cta-link">
          Hoe het werkt
          <i class="bi bi-arrow-right" aria-hidden="true"></i>
        </router-link>
      </div>

    </div>
  </section>
</template>

<script setup>
const usps = [
  {
    icon: 'bi-plug',
    title: 'Plug & Play installatie',
    body: 'Zelf installeren in 30 minuten. Geen elektricien nodig.',
  },
  {
    icon: 'bi-award',
    title: 'Alleen A-merken',
    body: 'Hoymiles, Marstek, Conow, GoodWe: merken die 10+ jaar meegaan.',
  },
  {
    icon: 'bi-headset',
    title: 'Gratis technisch advies',
    body: 'Energiespecialisten via mail of chat. We reageren binnen 1 werkdag.',
  },
  {
    icon: 'bi-truck',
    title: 'Morgen in huis',
    body: 'Voor 15:00 besteld, morgen geleverd. Gratis verzending v.a. €50.',
  },
]
</script>

<style scoped>
.usps-section {
  padding: 4.5rem 0;
  background: #f9f9f7;
}

/* Header */
.usps-header {
  text-align: center;
  margin-bottom: 2.5rem;
}

.eyebrow {
  display: inline-block;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #7a5f00;
  background: #FFF3B0;
  padding: 0.25rem 0.75rem;
  border-radius: 50px;
  margin-bottom: 1rem;
}

.usps-title {
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 900;
  color: #111;
  letter-spacing: -0.02em;
  line-height: 1.2;
  margin: 0;
}

/* Grid */
.usps-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  list-style: none;
  padding: 0;
  margin: 0;
}

/* Card */
.usp-card {
  background: #fff;
  border: 1.5px solid #eee;
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;
  position: relative;
  overflow: hidden;
}
.usp-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 3px;
  background: #FFD500;
  opacity: 0;
  transition: opacity 0.2s;
}
.usp-card:hover {
  border-color: #FFD500;
  box-shadow: 0 4px 20px rgba(0,0,0,0.07);
  transform: translateY(-3px);
}
.usp-card:hover::before {
  opacity: 1;
}

.usp-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.usp-num {
  font-size: 0.68rem;
  font-weight: 800;
  color: #bbb;
  letter-spacing: 0.06em;
}

.usp-icon {
  width: 38px;
  height: 38px;
  background: #111;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  color: #FFD500;
  flex-shrink: 0;
}

.usp-title {
  font-size: 0.9375rem;
  font-weight: 800;
  color: #111;
  line-height: 1.3;
  margin: 0;
}

.usp-body {
  font-size: 0.8125rem;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

/* Footer */
.usps-footer {
  margin-top: 2rem;
  text-align: center;
}

.cta-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 700;
  color: #111;
  text-decoration: none;
  border-bottom: 2px solid #FFD500;
  padding-bottom: 1px;
  transition: gap 0.18s;
}
.cta-link:hover { gap: 0.75rem; }

/* Responsive */
@media (max-width: 900px) {
  .usps-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 500px) {
  .usps-grid { grid-template-columns: 1fr; }
}
@media (prefers-reduced-motion: reduce) {
  .usp-card { transition: none; }
}
</style>
